import TransactionRepository from "../../internals/repository/TransactionRepository";

export const ModuleEvents = {
    FETCH_ORDER_TRANSACTIONS: "FETCH_ORDER_TRANSACTIONS",
};

const createAction =
  (type, action = () => {}, meta) =>
  (...args) => ({
    type,
    payload: action(...args),
    meta,
  });

const fetchOrderTransactions = createAction(
  ModuleEvents.FETCH_ORDER_TRANSACTIONS,
  async (shopId, limit = 10, lastKey = null) => {
    return;
  },
  { loading: true }
);

const exportedFuction = {
    fetchOrderTransactions,
};

export default exportedFuction;
